import React from "react";
import {useAppSelector} from "../../../utils/Hooks";

interface TopClientsTableProps {
    fromDate: string;
    toDate: string;
}

export const TopClientsTable: React.FC<TopClientsTableProps> = ({ fromDate, toDate }) => {

    const {topClients, userTopClients} = useAppSelector((state) => state.clients);

    return (
        <div>
            <table className="data">
                <thead>
                <tr>
                    <th style={{width: '20px'}}>Nr</th>
                    <th>Nimi</th>
                    <th style={{fontSize: '10px'}}>Perioodi kasum</th>
                </tr>
                </thead>
                <tbody>
                {topClients.map((client:any, index:number) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{client.client.name}</td>
                        <td>{client.profit.toFixed(2)}</td>
                    </tr>
                ))}
                </tbody>
            </table>

            {userTopClients.map((user:any) => (
                <div key={user.id}>
                    <h1>{`${user.firstname} ${user.lastname} top kliendid ${fromDate} - ${toDate}`}</h1>
                    <table className="data">
                        <thead>
                        <tr>
                            <th style={{width: '20px'}}>Nr</th>
                            <th>Nimi</th>
                            <th style={{fontSize: '10px'}}>Perioodi kasum</th>
                        </tr>
                        </thead>
                        <tbody>
                        {user.top.map((client:any, index:number) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{client.client.name}</td>
                                <td>{client.profit.toFixed(2)}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );

}